var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup9175(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 4.5,
    fill: "#12C730",
    stroke: "#12C730"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4376_489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.3186 16.431L20.4996 30.249C20.4067 30.3423 20.2963 30.4163 20.1747 30.4668C20.0531 30.5173 19.9228 30.5433 19.7911 30.5433C19.6595 30.5433 19.5291 30.5173 19.4075 30.4668C19.286 30.4163 19.1755 30.3423 19.0826 30.249L13.7386 24.9C13.6457 24.8067 13.5353 24.7327 13.4137 24.6822C13.2921 24.6317 13.1618 24.6057 13.0301 24.6057C12.8985 24.6057 12.7681 24.6317 12.6465 24.6822C12.525 24.7327 12.4145 24.8067 12.3216 24.9C12.2284 24.9929 12.1543 25.1033 12.1038 25.2249C12.0533 25.3465 12.0273 25.4769 12.0273 25.6085C12.0273 25.7402 12.0533 25.8705 12.1038 25.9921C12.1543 26.1137 12.2284 26.2241 12.3216 26.317L17.6676 31.662C18.2316 32.2249 18.9958 32.5411 19.7926 32.5411C20.5894 32.5411 21.3537 32.2249 21.9176 31.662L35.7356 17.847C35.8288 17.7541 35.9026 17.6438 35.9531 17.5223C36.0035 17.4008 36.0294 17.2705 36.0294 17.139C36.0294 17.0075 36.0035 16.8772 35.9531 16.7557C35.9026 16.6343 35.8288 16.5239 35.7356 16.431C35.6427 16.3377 35.5323 16.2637 35.4107 16.2132C35.2891 16.1627 35.1588 16.1367 35.0271 16.1367C34.8955 16.1367 34.7651 16.1627 34.6435 16.2132C34.522 16.2637 34.4115 16.3377 34.3186 16.431Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4376_489"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup9175);
export default __webpack_public_path__ + "static/media/Group 9175.884e58ef.svg";
export { ForwardRef as ReactComponent };